var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "container",
    attrs: {
      "id": "createSellerAccount"
    }
  }, [_c('section', {
    staticClass: "steps entry-steps"
  }), _vm._v(" "), _c('section', {
    staticClass: "formContainer"
  }, [_c('div', {
    staticClass: "entry-card"
  }, [_c('h2', {
    staticClass: "entry-title"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('createSellerAccount.entry.title')) + "\n      ")]), _vm._v(" "), _c('p', {
    staticClass: "entry-question"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('createSellerAccount.entry.question')) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "entry-options"
  }, [_c('label', {
    staticClass: "entry-option",
    class: {
      active: _vm.selectedOption === 'has'
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.selectedOption,
      expression: "selectedOption"
    }],
    attrs: {
      "name": "seller-entry-option",
      "type": "radio",
      "value": "has"
    },
    domProps: {
      "checked": _vm._q(_vm.selectedOption, "has")
    },
    on: {
      "change": function ($event) {
        _vm.selectedOption = "has";
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "entry-option-content"
  }, [_c('div', {
    staticClass: "entry-option-title"
  }, [_c('span', {
    staticClass: "entry-option-en"
  }, [_vm._v("\n              " + _vm._s(_vm.$t('createSellerAccount.entry.hasAccount')) + "\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "entry-option-desc"
  }, [_c('span', {
    staticClass: "entry-option-en"
  }, [_vm._v("\n              " + _vm._s(_vm.$t('createSellerAccount.entry.hasAccountDesc')) + "\n            ")])])])]), _vm._v(" "), _c('label', {
    staticClass: "entry-option",
    class: {
      active: _vm.selectedOption === 'none'
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.selectedOption,
      expression: "selectedOption"
    }],
    attrs: {
      "name": "seller-entry-option",
      "type": "radio",
      "value": "none"
    },
    domProps: {
      "checked": _vm._q(_vm.selectedOption, "none")
    },
    on: {
      "change": function ($event) {
        _vm.selectedOption = "none";
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "entry-option-content"
  }, [_c('div', {
    staticClass: "entry-option-title"
  }, [_c('span', {
    staticClass: "entry-option-en"
  }, [_vm._v("\n              " + _vm._s(_vm.$t('createSellerAccount.entry.noAccount')) + "\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "entry-option-desc"
  }, [_c('span', {
    staticClass: "entry-option-en"
  }, [_vm._v("\n              " + _vm._s(_vm.$t('createSellerAccount.entry.noAccountDesc')) + "\n            ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "tc"
  }, [_c('button', {
    staticClass: "myBtn sendCodeBtn entry-next",
    attrs: {
      "type": "button",
      "disabled": !_vm.selectedOption
    },
    on: {
      "click": _vm.handleNext
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('createSellerAccount.next')) + "\n        ")])])])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }